import config from '../config';
import Request from './request';

const { aws: { api: { invokeUrl } } } = config;

export const getPhaseConfig = () => Request.get(`${invokeUrl}/admin/phases`, true);
export const updatePhaseConfig = (phases) => Request.patch(`${invokeUrl}/admin/phases`, { phases }, true);
